import React from 'react';
import { CountdownRing } from '../CountdownRing';
import { BRAND, TOTAL_SECONDS } from '../../data/teaser';
interface ScreenPromiseProps {
  onStart: () => void;
}
export function ScreenPromise({
  onStart
}: ScreenPromiseProps) {
  return <section className="flex h-full w-full flex-col items-center justify-center text-center" data-id="element-68" data-mp="2vw4wwioal9rd">
      <p className="font-body text-sm font-semibold tracking-[0.28em] text-solventum-primary opacity-0-init animate-fade-in" data-id="element-69" data-mp="30u6fz3lpx92u">
        {BRAND}
      </p>

      <div className="mt-4 opacity-0-init animate-pop-in" style={{
      animationDelay: '80ms'
    }} data-id="element-70" data-mp="3ti2feg2o9f3b">
        <CountdownRing remaining={TOTAL_SECONDS} variant="hero" data-id="element-71" data-mp="3fit680cvvl8u" />
      </div>

      <h1 className="mt-6 text-[27px] font-extrabold leading-[1.15] text-white opacity-0-init animate-fade-in-up" style={{
      animationDelay: '200ms'
    }} data-id="element-72" data-mp="3fkvuaeuh74ax">
        Invest the next 30 seconds and see how you can save 12 minutes on every
        attachment bonding procedure.
      </h1>

      <p className="mt-4 font-body text-xs text-white/45 opacity-0-init animate-fade-in-up" style={{
      animationDelay: '320ms'
    }} data-id="element-73" data-mp="282mwdil7lt0b">
        12 minutes saved per bonding procedure, on average.
      </p>

      <p className="mt-6 font-body text-sm text-solventum-primary opacity-0-init animate-fade-in-up" style={{
      animationDelay: '400ms'
    }} data-id="element-74" data-mp="28oc1xif0s086">
        Press start when you’re ready. The clock starts now.
      </p>

      <button onClick={onStart} className="mt-6 w-full rounded-2xl bg-solventum-primary px-6 py-4 font-headline text-lg font-extrabold text-solventum-bg shadow-[0_0_24px_rgba(5,221,77,0.25)] transition-transform duration-150 active:scale-[0.98] opacity-0-init animate-fade-in-up" style={{
      animationDelay: '480ms'
    }} data-id="element-75" data-mp="2ikp474omrmej">
        Start the 30 seconds →
      </button>
    </section>;
}